import PromptStore from 'stores/PromptStore';
import GroupStore from 'groups/stores/GroupStore';
import GroupActions from 'groups/actions/GroupActions';
import { PromptNames } from 'constants/PromptConstants';

export const SKIP_ROSTER_CONFIRM = 'skip-roster-confirm';

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
function needsSchool(user) {
  const groupsJoined = GroupStore.getGroupsJoinedDuringSetup();
  const joinedGroupWithSchool =
    groupsJoined && groupsJoined.some((group) => group.getOrganization());

  return user.getNeeds().organization && !joinedGroupWithSchool;
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
function needsGroup(user) {
  return (
    !PromptStore.hasDismissed(PromptNames.NUX_SETUP_CLASS) &&
    user.needsGroups() && // User object isn't updated when a group is created
    GroupStore.getOwnedGroups().length === 0
  );
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
function needsSignature(user) {
  return (
    user.getNeeds().signature &&
    !user.getSignature() &&
    user.getSignInCount() <= 2 &&
    !PromptStore.hasDismissed(PromptNames.NUX_SETUP_SIGNATURE)
  );
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
function needsSmsDevice(user) {
  if (
    user.hasFeature('claim_devices.web.july-31') ||
    user.getRole() === 'student' ||
    user.getRole() === 'parent'
  ) {
    return (
      user.getSignInCount() <= 2 &&
      user.hasSmsSupported() &&
      // The user isn't updated after this setup step completes, but it works anyway because of the prompt. If removing the prompt, you'll need to retetch the user after they finish this setup step.
      !user.hasSmsDevice() &&
      !PromptStore.hasDismissed(PromptNames.NUX_SETUP_SMS_DEVICE)
    );
  }

  return false;
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
function needsSubscription(user) {
  return (
    user.getSignInCount() <= 2 &&
    user.getNeeds().subscriptions &&
    !PromptStore.hasDismissed(PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION)
  );
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
function needsFullName(user) {
  return user.getNeeds().full_name;
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
function needsEmail(user) {
  if (user.hasFeature('claim_devices.web.july-31') || user.getRole() === 'teacher') {
    return !user.hasEmail() && !PromptStore.hasDismissed(PromptNames.NUX_SETUP_EMAIL_DEVICE);
  }

  return false;
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
function needRole(user) {
  return user.getNeeds().role;
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
function needsPassword(user) {
  return user.getNeeds().password;
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
function needPIIConsent(user) {
  return user.getNeeds().pii_consent;
}

// student always need a birthdate (new 2018 ikeepsafe requirement)
// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
function needStudentBirthdate(user) {
  return !user.getBirthdate();
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
function needsParentEmail(user) {
  return user.getNeeds().parent_email;
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
function needsRosterChoose(user) {
  return user.getNeeds().roster_choose;
}

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
function needsRosterConfirm(user) {
  if (window.localStorage.getItem(SKIP_ROSTER_CONFIRM)) {
    return false;
  }

  return user.getNeeds().roster_confirm;
}

function clearSetupData() {
  // Prevents "Can't dispatch within a dispatch" error when booting the app. The other dispatch is loading groups.
  setTimeout(() => {
    GroupActions.clearGroupsJoinedDuringSetup();
  }, 0);
}

type Steps = {
  if: (user: any) => boolean;
  step: string;
};

// prettier-ignore
const prerequisites: Array<Steps> = [
  { if: needPIIConsent, step: '/setup/pii'      },
  { if: needsPassword,  step: '/setup/password' },
  { if: needsFullName,  step: '/setup/name'     },
  { if: needRole,       step: '/setup/role'     },
];

// prettier-ignore
const steps: {
  [x: string]: Array<Steps>
} = {
  teacher: [
    { if: needsSignature,         step: '/setup/signature'      },
    { if: needsEmail,             step: '/setup/email'          },
    { if: needsSmsDevice,         step: '/setup/device/sms'     },
    { if: needsGroup,             step: '/setup/class'          },
    { if: needsSchool,            step: '/setup/school'         },
    { if: needsRosterConfirm,     step: '/setup/roster/confirm' },
    { if: needsRosterChoose,      step: '/setup/roster/choose'  },
  ],
  student: [
    { if: needsFullName,          step: '/setup/name'             },
    { if: needStudentBirthdate,   step: '/setup/birthdate'        },
    { if: needsParentEmail,       step: '/setup/parent_email'     },
    { if: needsEmail,             step: '/setup/email'            },
    { if: needsSmsDevice,         step: '/setup/device/sms'       },
    { if: needsSubscription,      step: '/setup/subscriptions'    },
    { if: needsRosterConfirm,     step: '/setup/roster/confirm'   },
    { if: needsRosterChoose,      step: '/setup/roster/choose'    },
  ],
  parent: [
    { if: needsEmail,             step: '/setup/email'          },
    { if: needsSmsDevice,         step: '/setup/device/sms'     },
    { if: needsSubscription,      step: '/setup/subscriptions'  },
    { if: needsRosterConfirm,     step: '/setup/roster/confirm' },
    { if: needsRosterChoose,      step: '/setup/roster/choose'  },
  ],
};

// prettier-ignore
const prerequisitesStreamlinedSignUp: Array<Steps> = [
  { if: needPIIConsent, step: '/setup/pii' },
  { if: needRole, step: '/setup/role' }
];

// prettier-ignore
const streamlinedSignUp: {
  [x: string]: Array<Steps>
} = {
  student: [
    { if: needStudentBirthdate, step: '/setup/birthdate' }
  ]
};

function getStepsForRole(role?: string | null): Array<Steps> {
  return [...prerequisites, ...(role ? steps[role] || [] : [])];
}

function getStepsForStreamLinedSignUp(role?: string | null): Array<Steps> {
  return [...prerequisitesStreamlinedSignUp, ...(role ? streamlinedSignUp[role] || [] : [])];
}

export default {
  getNextEligibleStep: (user: any, isStreamLinedSignUp?: boolean | null) => {
    const fnToGetEligibleStep = isStreamLinedSignUp
      ? getStepsForStreamLinedSignUp
      : getStepsForRole;
    const stepsForRole = fnToGetEligibleStep(user.getRole());
    const eligibleStep = stepsForRole.find((step) => step.if(user));

    if (eligibleStep) {
      return eligibleStep.step;
    }

    clearSetupData();
    return undefined;
  },
};
